import { dynamicImports as Oe } from "@sunrise/components";
import { hydrate as _e } from "@sunrise/hydration";
import { commonUtils as bt, mediaQueryObserver as B, assetLoader as T, inViewDetector as ot, resizeObserver as Kt, useGlobalStore as f, sourcePoint as D } from "@sunrise/shared";
import { setup as Fe } from "@sunrise/tracking";
import { Ads as W, ScreenSize as yt, TCF as $e } from "@sunrise/types";
import xe from "axios";
let it;
const Tt = [];
function Re() {
  return Tt.length === 0 ? Promise.resolve() : Promise.all(Tt.map((t) => new Promise((e) => t(it, e))));
}
async function Xt(t) {
  return it = t, Re();
}
function O() {
  return it;
}
const ht = 1080;
function Yt() {
  const t = document.querySelector(".js-p5-selector");
  t && (window.innerHeight <= ht ? t.style.paddingTop = `calc(100vh - ${bt.getOffsetTopToDocument(t)}px)` : t.style.paddingTop = `calc(${ht}px - ${bt.getOffsetTopToDocument(t)}px)`);
}
function at(t) {
  const e = B.getCurrentScreenSizes();
  return t.filter((n) => n.device === W.Device.ALL ? !0 : e >= yt.M ? n.position === "p5" && e < yt.XL ? !1 : n.device === W.Device.DESKTOP : n.device === W.Device.MOBILE);
}
let St = !1, At = 0;
const $ = {};
function Me() {
  window.googletag.cmd.push(
    () => window.googletag.pubads().addEventListener("slotVisibilityChanged", Ue)
  );
}
function Ue(t) {
  Object.values($).forEach((e) => {
    e(t, t.slot.getSlotElementId());
  });
}
function Be(t) {
  return St || (Me(), St = !0), $[++At] = t, At;
}
function Ve(t) {
  return $[t] ? (delete $[t], !0) : !1;
}
const qe = 60 * 60 * 1e3, st = "ms_interstitial", Jt = -1, Ne = 1;
let Qt;
function Ge() {
  return Zt(), (t) => {
    ct(t) && ne();
  };
}
function He() {
  Qt = Be(Ye), Zt();
}
function Zt() {
  const t = ee();
  return t === 0 && window.localStorage.setItem(st, Jt.toString()), !t;
}
function V(t) {
  if (!oe(t))
    return !0;
  const e = Date.now(), n = ee();
  return ct(t) ? We(e, n) : ze(e, n);
}
function ze(t, e) {
  return !te(t, e);
}
function We(t, e) {
  return !Ke(e) && !te(t, e);
}
function Ke(t) {
  const e = t === Jt;
  return e && re(Ne), e;
}
function te(t, e) {
  return t - e <= qe;
}
function ee() {
  const t = window.localStorage.getItem(st);
  return t ? Number.parseInt(t, 10) : 0;
}
function ne() {
  const t = Date.now();
  re(t);
}
function Xe(t) {
  if (J(t))
    return;
  const n = O().gptSlots.filter((r) => J(r.getSlotElementId()));
  window.googletag.destroySlots(n);
}
function re(t) {
  window.localStorage.setItem(st, t.toString());
}
function Ye(t, e) {
  t.inViewPercentage === 100 && oe(e) && (ne(), Xe(e), Ve(Qt));
}
function oe(t) {
  return ct(t) || J(t);
}
function J(t) {
  return t == null ? void 0 : t.includes("wi");
}
function ct(t) {
  return (t == null ? void 0 : t.indexOf("m9")) >= 0;
}
let ie;
function Je() {
  T.load("https://cdn.adnuntius.com/adn.js"), ie = Ge(), window.adn = window.adn || {}, window.adn.calls = window.adn.calls || [], window.adn.calls.push(() => {
    window.adn.useLocalStorage(!1), ae();
  }), Yt(), B.subscribe(tn);
}
function Qe() {
  return {
    useCookies: !1,
    isolateFrame: !0,
    adUnits: Ze(),
    onAllResponses: (t) => t.forEach((e) => ie(e.targetId))
  };
}
function Ze() {
  return O().viewportAdUnits.filter((e) => !!e.adNuntiusId && V(e.position)).map((e) => ({
    auId: e.adNuntiusId || "",
    useCookies: !1,
    targetId: e.position,
    kv: {
      cookie: ["false"]
    }
  }));
}
async function tn(t, e) {
  if (!e)
    return;
  const n = O(), r = at(n == null ? void 0 : n.ads.adUnits);
  await Xt({
    ...n,
    ads: n == null ? void 0 : n.ads,
    viewportAdUnits: r,
    gptSlots: []
  }), en(), ae();
}
function ae() {
  const t = Qe();
  window.adn.calls.push(() => window.adn.request(t));
}
function en() {
  const { viewportAdUnits: t } = O();
  t.forEach((e) => {
    const n = document.getElementById(e.position);
    n && (n.innerHTML = "");
  });
}
let Et = !1, Ct = 0;
const x = {};
function nn() {
  window.googletag.cmd.push(() => window.googletag.pubads().addEventListener("slotRenderEnded", rn));
}
function rn(t) {
  Object.values(x).forEach((e) => {
    e(t, t.slot.getSlotElementId());
  });
}
function on(t) {
  return Et || (nn(), Et = !0), x[++Ct] = t, Ct;
}
function an(t) {
  return x[t] ? (delete x[t], !0) : !1;
}
const ut = "-m0sticky", sn = -1;
let g, d, Q = [], y, se;
function cn() {
  return d != null && d.classList.contains(ut) ? (d.style.transitionProperty = "transform", d.style.transitionDuration = "300ms", d.style.transitionTimingFunction = "cubic-bezier(0.4, 0, 0.2, 1)", d.style.transform = "translateY(-100%)", new Promise((t) => {
    setTimeout(() => {
      ce(), d && (d.style.transitionDuration = "", d.style.transitionProperty = "", d.style.transitionTimingFunction = "", d.style.transform = ""), t();
    }, 300);
  })) : Promise.resolve();
}
async function un() {
  Q.forEach((t) => ot.unobserve(t)), Q = [], y == null || y.kill(), Kt.unobserve(se), await cn();
}
function ce() {
  d == null || d.classList.remove(ut);
}
function dn() {
  d == null || d.classList.add(ut);
}
function ue() {
  const t = document.createElement("div");
  t.style.position = "absolute", t.style.top = "100vh", t.style.height = "1px", t.style.width = "100vw", g == null || g.appendChild(t), setTimeout(() => {
    const e = ot.observe(
      t,
      () => {
        dn(), t.remove(), ln();
      },
      !0
    );
    e && Q.push(e);
  }, 10);
}
function ln() {
  y == null || y.observe(
    g,
    () => {
      ce(), ue();
    },
    !0
  );
}
function fn() {
  g.style.position = "relative";
}
function de(t) {
  g.style.minHeight = `${t}px`;
}
function gn(t) {
  de(t.borderBoxSize[t.borderBoxSize.length - 1].blockSize);
}
function pn() {
  const t = mn();
  if (g = document.querySelector(".js-m0-selector"), !g || !t || (d = g.firstElementChild, !d))
    return !1;
  y = ot.createObserver({
    threshold: 1
  }), fn(), se = Kt.observe(g, gn), ue();
  const e = on((n, r) => {
    r === "m0" && (t.stickyTimeout !== sn && setTimeout(un, t.stickyTimeout), de(g.offsetHeight), e && an(e));
  });
  return !0;
}
function mn() {
  const t = O();
  return t == null ? void 0 : t.ads.adUnits.find((e) => e.position === "m0");
}
var wn = Object.prototype;
function le(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || wn;
  return t === n;
}
function vn(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var bn = vn(Object.keys, Object), yn = Object.prototype, Tn = yn.hasOwnProperty;
function hn(t) {
  if (!le(t))
    return bn(t);
  var e = [];
  for (var n in Object(t))
    Tn.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
var fe = typeof global == "object" && global && global.Object === Object && global, Sn = typeof self == "object" && self && self.Object === Object && self, v = fe || Sn || Function("return this")(), R = v.Symbol, ge = Object.prototype, An = ge.hasOwnProperty, En = ge.toString, C = R ? R.toStringTag : void 0;
function Cn(t) {
  var e = An.call(t, C), n = t[C];
  try {
    t[C] = void 0;
    var r = !0;
  } catch {
  }
  var o = En.call(t);
  return r && (e ? t[C] = n : delete t[C]), o;
}
var Ln = Object.prototype, jn = Ln.toString;
function In(t) {
  return jn.call(t);
}
var Pn = "[object Null]", Dn = "[object Undefined]", Lt = R ? R.toStringTag : void 0;
function _(t) {
  return t == null ? t === void 0 ? Dn : Pn : Lt && Lt in Object(t) ? Cn(t) : In(t);
}
function pe(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var kn = "[object AsyncFunction]", On = "[object Function]", _n = "[object GeneratorFunction]", Fn = "[object Proxy]";
function me(t) {
  if (!pe(t))
    return !1;
  var e = _(t);
  return e == On || e == _n || e == kn || e == Fn;
}
var K = v["__core-js_shared__"], jt = function() {
  var t = /[^.]+$/.exec(K && K.keys && K.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function $n(t) {
  return !!jt && jt in t;
}
var xn = Function.prototype, Rn = xn.toString;
function h(t) {
  if (t != null) {
    try {
      return Rn.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var Mn = /[\\^$.*+?()[\]{}|]/g, Un = /^\[object .+?Constructor\]$/, Bn = Function.prototype, Vn = Object.prototype, qn = Bn.toString, Nn = Vn.hasOwnProperty, Gn = RegExp(
  "^" + qn.call(Nn).replace(Mn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Hn(t) {
  if (!pe(t) || $n(t))
    return !1;
  var e = me(t) ? Gn : Un;
  return e.test(h(t));
}
function zn(t, e) {
  return t == null ? void 0 : t[e];
}
function F(t, e) {
  var n = zn(t, e);
  return Hn(n) ? n : void 0;
}
var Z = F(v, "DataView"), tt = F(v, "Map"), et = F(v, "Promise"), nt = F(v, "Set"), rt = F(v, "WeakMap"), It = "[object Map]", Wn = "[object Object]", Pt = "[object Promise]", Dt = "[object Set]", kt = "[object WeakMap]", Ot = "[object DataView]", Kn = h(Z), Xn = h(tt), Yn = h(et), Jn = h(nt), Qn = h(rt), b = _;
(Z && b(new Z(new ArrayBuffer(1))) != Ot || tt && b(new tt()) != It || et && b(et.resolve()) != Pt || nt && b(new nt()) != Dt || rt && b(new rt()) != kt) && (b = function(t) {
  var e = _(t), n = e == Wn ? t.constructor : void 0, r = n ? h(n) : "";
  if (r)
    switch (r) {
      case Kn:
        return Ot;
      case Xn:
        return It;
      case Yn:
        return Pt;
      case Jn:
        return Dt;
      case Qn:
        return kt;
    }
  return e;
});
function dt(t) {
  return t != null && typeof t == "object";
}
var Zn = "[object Arguments]";
function _t(t) {
  return dt(t) && _(t) == Zn;
}
var we = Object.prototype, tr = we.hasOwnProperty, er = we.propertyIsEnumerable, nr = _t(/* @__PURE__ */ function() {
  return arguments;
}()) ? _t : function(t) {
  return dt(t) && tr.call(t, "callee") && !er.call(t, "callee");
}, rr = Array.isArray, or = 9007199254740991;
function ve(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= or;
}
function ir(t) {
  return t != null && ve(t.length) && !me(t);
}
function ar() {
  return !1;
}
var be = typeof exports == "object" && exports && !exports.nodeType && exports, Ft = be && typeof module == "object" && module && !module.nodeType && module, sr = Ft && Ft.exports === be, $t = sr ? v.Buffer : void 0, cr = $t ? $t.isBuffer : void 0, ur = cr || ar, dr = "[object Arguments]", lr = "[object Array]", fr = "[object Boolean]", gr = "[object Date]", pr = "[object Error]", mr = "[object Function]", wr = "[object Map]", vr = "[object Number]", br = "[object Object]", yr = "[object RegExp]", Tr = "[object Set]", hr = "[object String]", Sr = "[object WeakMap]", Ar = "[object ArrayBuffer]", Er = "[object DataView]", Cr = "[object Float32Array]", Lr = "[object Float64Array]", jr = "[object Int8Array]", Ir = "[object Int16Array]", Pr = "[object Int32Array]", Dr = "[object Uint8Array]", kr = "[object Uint8ClampedArray]", Or = "[object Uint16Array]", _r = "[object Uint32Array]", a = {};
a[Cr] = a[Lr] = a[jr] = a[Ir] = a[Pr] = a[Dr] = a[kr] = a[Or] = a[_r] = !0;
a[dr] = a[lr] = a[Ar] = a[fr] = a[Er] = a[gr] = a[pr] = a[mr] = a[wr] = a[vr] = a[br] = a[yr] = a[Tr] = a[hr] = a[Sr] = !1;
function Fr(t) {
  return dt(t) && ve(t.length) && !!a[_(t)];
}
function $r(t) {
  return function(e) {
    return t(e);
  };
}
var ye = typeof exports == "object" && exports && !exports.nodeType && exports, I = ye && typeof module == "object" && module && !module.nodeType && module, xr = I && I.exports === ye, X = xr && fe.process, xt = function() {
  try {
    var t = I && I.require && I.require("util").types;
    return t || X && X.binding && X.binding("util");
  } catch {
  }
}(), Rt = xt && xt.isTypedArray, Rr = Rt ? $r(Rt) : Fr, Mr = "[object Map]", Ur = "[object Set]", Br = Object.prototype, Vr = Br.hasOwnProperty;
function Te(t) {
  if (t == null)
    return !0;
  if (ir(t) && (rr(t) || typeof t == "string" || typeof t.splice == "function" || ur(t) || Rr(t) || nr(t)))
    return !t.length;
  var e = b(t);
  if (e == Mr || e == Ur)
    return !t.size;
  if (le(t))
    return !hn(t).length;
  for (var n in t)
    if (Vr.call(t, n))
      return !1;
  return !0;
}
const qr = "//securepubads.g.doubleclick.net/tag/js/gpt.js", Nr = "https://meinestadt-cdn.relevant-digital.com/static/tags/645215273a9d615477d5bcb4.js", Gr = "64522bb38a27302411d5bd1f", Hr = 126611261, zr = "hbmId", k = /* @__PURE__ */ new Map(), Mt = /* @__PURE__ */ new Map();
async function Wr() {
  io(), He(
    /* must be loaded pretty early, due to mandatory consent check */
  ), ao(
    /* we want to queue up targeting asap to prevent race conditions  */
  ), oo(), ro(), Xr(), Kr(), Zr(), he(), pn(), Yt(), q(), uo();
}
function he(t) {
  const n = A().find((r) => r.includes("wi"));
  !n || !V(n) || googletag.cmd.push(() => {
    const r = googletag.defineOutOfPageSlot(
      Se(n),
      // @ts-ignore
      googletag.enums.OutOfPageFormat.INTERSTITIAL
    );
    r && (r.setForceSafeFrame(!0), r.addService(googletag.pubads()));
  });
}
function Kr() {
  B.subscribe((t, e) => {
    var r, o;
    if (!e)
      return;
    const n = A();
    k.forEach((i, c) => lt(n, c, i)), (o = (r = window.relevantDigital) == null ? void 0 : r.destroySlots) == null || o.call(r), he(), setTimeout(
      Ee,
      0
      /* make room for browser to update */
    );
  });
}
function Xr() {
  const t = A();
  document.querySelectorAll("[data-ad-unit-id]").forEach((e) => {
    const n = e.dataset.adUnitId || "";
    n && (k.has(n) || k.set(n, e), lt(t, n, e));
  });
}
function Yr(t) {
  const e = t.map((r) => Ce(r)).filter((r) => !!r), n = Jr(e);
  Te(n) || setTimeout(
    () => q({
      allowedDivIds: n.map((r) => r.position)
    }),
    0
  );
}
function Jr(t) {
  const e = A();
  return t.filter((n) => {
    const r = document.getElementById(n.position);
    return !r || !n ? !1 : (k.set(n.id, r), lt(e, n.id, r), !0);
  });
}
function Qr() {
  const t = A(), e = [];
  return k.forEach((n, r) => {
    t.includes(r) && V(r) && Ae(r) && e.push(n.id);
  }), e;
}
function lt(t, e, n) {
  t.includes(e) ? n.dataset.adUnitId = Se(e) : delete n.dataset.adUnitId;
}
function Se(t) {
  return `/${Hr}/${t}`;
}
function A() {
  var e;
  const t = (e = f().ads) == null ? void 0 : e.adUnits;
  return t ? at(t).map((n) => n.id) : [];
}
function Zr() {
  window.refreshAds = Ee, window.refreshAd = to, window.addNewAdUnits = Yr;
}
function Ae(t) {
  var o;
  const e = /* @__PURE__ */ new Date(), n = Mt.get(t), r = ((o = f().ads) == null ? void 0 : o.reloadThrottleInterval) || 5e3;
  return !n || e.getTime() - n.getTime() > r ? (Mt.set(t, e), !0) : !1;
}
function Ee() {
  q();
}
function to(t) {
  var n;
  const e = (n = Ce(t)) == null ? void 0 : n.id;
  t === "m9" && !V(t) || !e || !Ae(e) || q({
    allowedDivIds: [t]
  });
}
function Ce(t) {
  var e;
  return (e = f().ads) == null ? void 0 : e.adUnits.find((n) => n.position === t);
}
function q(t) {
  var e, n;
  (n = (e = window.relevantDigital) == null ? void 0 : e.cmd) == null || n.push(() => {
    var o, i;
    const r = eo(t);
    r.allowedDivIds || (r.allowedDivIds = Qr()), Te(r.allowedDivIds) || (i = (o = window == null ? void 0 : window.relevantDigital) == null ? void 0 : o.loadPrebid) == null || i.call(o, r);
  });
}
function eo(t) {
  const e = {
    configId: no(),
    manageAdserver: !0,
    collapseEmptyDivs: !0,
    collapseBeforeAdFetch: !1,
    noGpt: !0
  };
  return Object.assign({}, e, t);
}
function no() {
  var n;
  return new URL(window.location.href).searchParams.get(zr) || ((n = f().ads) == null ? void 0 : n.hbManagerConfigId) || Gr;
}
async function ro() {
  var e;
  const t = ((e = f().ads) == null ? void 0 : e.hbManagerTag) || Nr;
  return T.load(t);
}
function oo() {
  return T.load(qr);
}
function io() {
  window.googletag = window.googletag || {}, window.googletag.cmd = window.googletag.cmd || [], window.pbjs = window.pbjs || {}, window.pbjs.que = window.pbjs.que || [], window.relevantDigital = window.relevantDigital || {}, window.relevantDigital.cmd = window.relevantDigital.cmd || [];
}
function ao() {
  googletag.cmd.push(() => {
    const t = co(), e = f().ads;
    Object.entries((e == null ? void 0 : e.targeting) || {}).forEach(([n, r]) => googletag.pubads().setTargeting(n, r + "")), googletag.pubads().setTargeting("Stunde", (/* @__PURE__ */ new Date()).getHours().toString()), e != null && e.fpTestEnabled && googletag.pubads().setTargeting("Testing", so()), t && googletag.pubads().setTargeting("testAds", t);
  });
}
function so() {
  const t = Math.random();
  return t <= 0.8 ? "X" : t <= 0.82 ? "A" : t <= 0.84 ? "B" : t <= 0.86 ? "C" : t <= 0.88 ? "D" : t <= 0.9 ? "E" : t <= 0.92 ? "F" : t <= 0.94 ? "G" : t <= 0.96 ? "H" : t <= 0.98 ? "I" : "J";
}
function co() {
  var r, o;
  const e = f().requestContext;
  return (o = (r = e == null ? void 0 : e.url) == null ? void 0 : r.searchParams) == null ? void 0 : o.get("testAds");
}
function uo() {
  window.adPlacements = A();
}
const lo = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
function fo() {
  return go() ? Promise.resolve() : T.load(lo).then(po);
}
function go() {
  return !document.querySelector(".ms-linkunits");
}
function po() {
  window.adsbygoogle = window.adsbygoogle || [], window.adsbygoogle.push({});
}
function mo() {
  return T.load("//ap.lijit.com/www/sovrn_beacon_standalone/sovrn_standalone_beacon.js?iid=13417343");
}
function wo() {
  return T.load("//get.s-onetag.com/3e41117b-d897-4135-afd7-079c11309b04/tag.min.js");
}
async function vo(t) {
  const e = await bo(t);
  return D.onConsentAvailablePromise().then(async (n) => {
    if (!D.hasConsent($e.Purpose.STORAGE, n)) {
      e.ads.adnuntiusEnabled && Je();
      return;
    }
    return await mo(), e.ads.sovrnSignalDisabled || await wo(), await Wr(), fo();
  });
}
async function bo(t) {
  const n = f(t).ads, r = at(n.adUnits), o = yo(t), i = {
    gptSlots: [],
    ads: n,
    viewportAdUnits: r,
    hasTestAds: !!o,
    testAds: o
  };
  return await Xt(i), i;
}
function yo(t) {
  var r, o;
  const n = f(t).requestContext;
  return !n || !((o = (r = n.url) == null ? void 0 : r.searchParams) != null && o.get("testAds")) ? null : n.url.searchParams.get("testAds");
}
const To = "https://www.google.com/adsense/search/async-ads.js";
async function ho(t) {
  return !t || t.adUnits.length === 0 ? Promise.resolve(null) : new Promise((e) => {
    D.onConsentAvailable(() => {
      D.loadCustomVendorConsents((n, r) => {
        if (!r || !Eo(n)) {
          e(null);
          return;
        }
        So(t), e(null);
      });
    });
  });
}
function So(t) {
  T.load(To).then(() => {
    window._googCsa && t.adUnits.forEach((e) => Ao(e, t));
  });
}
function Ao(t, e) {
  var r;
  const n = {
    pubId: e.googleAdClient,
    query: e.searchTerm,
    channel: e.googleAdChannel,
    plusOnes: e.plusOnes,
    sellerRatings: e.sellerRatings,
    siteLinks: e.siteLinks,
    styleId: e.styleId,
    hl: "de"
  };
  (r = window._googCsa) == null || r.call(window, "ads", n, t.props);
}
function Eo(t) {
  return !!t.consentedVendors.find((e) => e.name === "Google Ad Manager");
}
var w, P, Le, M, je = -1, E = function(t) {
  addEventListener("pageshow", function(e) {
    e.persisted && (je = e.timeStamp, t(e));
  }, !0);
}, ft = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, N = function() {
  var t = ft();
  return t && t.activationStart || 0;
}, p = function(t, e) {
  var n = ft(), r = "navigate";
  return je >= 0 ? r = "back-forward-cache" : n && (document.prerendering || N() > 0 ? r = "prerender" : document.wasDiscarded ? r = "restore" : n.type && (r = n.type.replace(/_/g, "-"))), { name: t, value: e === void 0 ? -1 : e, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: r };
}, G = function(t, e, n) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(t)) {
      var r = new PerformanceObserver(function(o) {
        Promise.resolve().then(function() {
          e(o.getEntries());
        });
      });
      return r.observe(Object.assign({ type: t, buffered: !0 }, n || {})), r;
    }
  } catch {
  }
}, m = function(t, e, n, r) {
  var o, i;
  return function(c) {
    e.value >= 0 && (c || r) && ((i = e.value - (o || 0)) || o === void 0) && (o = e.value, e.delta = i, e.rating = function(u, s) {
      return u > s[1] ? "poor" : u > s[0] ? "needs-improvement" : "good";
    }(e.value, n), t(e));
  };
}, gt = function(t) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return t();
    });
  });
}, pt = function(t) {
  var e = function(n) {
    n.type !== "pagehide" && document.visibilityState !== "hidden" || t(n);
  };
  addEventListener("visibilitychange", e, !0), addEventListener("pagehide", e, !0);
}, mt = function(t) {
  var e = !1;
  return function(n) {
    e || (t(n), e = !0);
  };
}, S = -1, Ut = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, U = function(t) {
  document.visibilityState === "hidden" && S > -1 && (S = t.type === "visibilitychange" ? t.timeStamp : 0, Co());
}, Bt = function() {
  addEventListener("visibilitychange", U, !0), addEventListener("prerenderingchange", U, !0);
}, Co = function() {
  removeEventListener("visibilitychange", U, !0), removeEventListener("prerenderingchange", U, !0);
}, wt = function() {
  return S < 0 && (S = Ut(), Bt(), E(function() {
    setTimeout(function() {
      S = Ut(), Bt();
    }, 0);
  })), { get firstHiddenTime() {
    return S;
  } };
}, H = function(t) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return t();
  }, !0) : t();
}, Vt = [1800, 3e3], Ie = function(t, e) {
  e = e || {}, H(function() {
    var n, r = wt(), o = p("FCP"), i = G("paint", function(c) {
      c.forEach(function(u) {
        u.name === "first-contentful-paint" && (i.disconnect(), u.startTime < r.firstHiddenTime && (o.value = Math.max(u.startTime - N(), 0), o.entries.push(u), n(!0)));
      });
    });
    i && (n = m(t, o, Vt, e.reportAllChanges), E(function(c) {
      o = p("FCP"), n = m(t, o, Vt, e.reportAllChanges), gt(function() {
        o.value = performance.now() - c.timeStamp, n(!0);
      });
    }));
  });
}, qt = [0.1, 0.25], Lo = function(t, e) {
  e = e || {}, Ie(mt(function() {
    var n, r = p("CLS", 0), o = 0, i = [], c = function(s) {
      s.forEach(function(l) {
        if (!l.hadRecentInput) {
          var z = i[0], vt = i[i.length - 1];
          o && l.startTime - vt.startTime < 1e3 && l.startTime - z.startTime < 5e3 ? (o += l.value, i.push(l)) : (o = l.value, i = [l]);
        }
      }), o > r.value && (r.value = o, r.entries = i, n());
    }, u = G("layout-shift", c);
    u && (n = m(t, r, qt, e.reportAllChanges), pt(function() {
      c(u.takeRecords()), n(!0);
    }), E(function() {
      o = 0, r = p("CLS", 0), n = m(t, r, qt, e.reportAllChanges), gt(function() {
        return n();
      });
    }), setTimeout(n, 0));
  }));
}, j = { passive: !0, capture: !0 }, jo = /* @__PURE__ */ new Date(), Nt = function(t, e) {
  w || (w = e, P = t, Le = /* @__PURE__ */ new Date(), De(removeEventListener), Pe());
}, Pe = function() {
  if (P >= 0 && P < Le - jo) {
    var t = { entryType: "first-input", name: w.type, target: w.target, cancelable: w.cancelable, startTime: w.timeStamp, processingStart: w.timeStamp + P };
    M.forEach(function(e) {
      e(t);
    }), M = [];
  }
}, Io = function(t) {
  if (t.cancelable) {
    var e = (t.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - t.timeStamp;
    t.type == "pointerdown" ? function(n, r) {
      var o = function() {
        Nt(n, r), c();
      }, i = function() {
        c();
      }, c = function() {
        removeEventListener("pointerup", o, j), removeEventListener("pointercancel", i, j);
      };
      addEventListener("pointerup", o, j), addEventListener("pointercancel", i, j);
    }(e, t) : Nt(e, t);
  }
}, De = function(t) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(e) {
    return t(e, Io, j);
  });
}, Gt = [100, 300], Po = function(t, e) {
  e = e || {}, H(function() {
    var n, r = wt(), o = p("FID"), i = function(s) {
      s.startTime < r.firstHiddenTime && (o.value = s.processingStart - s.startTime, o.entries.push(s), n(!0));
    }, c = function(s) {
      s.forEach(i);
    }, u = G("first-input", c);
    n = m(t, o, Gt, e.reportAllChanges), u && pt(mt(function() {
      c(u.takeRecords()), u.disconnect();
    })), u && E(function() {
      var s;
      o = p("FID"), n = m(t, o, Gt, e.reportAllChanges), M = [], P = -1, w = null, De(addEventListener), s = i, M.push(s), Pe();
    });
  });
}, Ht = [2500, 4e3], Y = {}, Do = function(t, e) {
  e = e || {}, H(function() {
    var n, r = wt(), o = p("LCP"), i = function(s) {
      var l = s[s.length - 1];
      l && l.startTime < r.firstHiddenTime && (o.value = Math.max(l.startTime - N(), 0), o.entries = [l], n());
    }, c = G("largest-contentful-paint", i);
    if (c) {
      n = m(t, o, Ht, e.reportAllChanges);
      var u = mt(function() {
        Y[o.id] || (i(c.takeRecords()), c.disconnect(), Y[o.id] = !0, n(!0));
      });
      ["keydown", "click"].forEach(function(s) {
        addEventListener(s, u, !0);
      }), pt(u), E(function(s) {
        o = p("LCP"), n = m(t, o, Ht, e.reportAllChanges), gt(function() {
          o.value = performance.now() - s.timeStamp, Y[o.id] = !0, n(!0);
        });
      });
    }
  });
}, zt = [800, 1800], ko = function t(e) {
  document.prerendering ? H(function() {
    return t(e);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return t(e);
  }, !0) : setTimeout(e, 0);
}, Oo = function(t, e) {
  e = e || {};
  var n = p("TTFB"), r = m(t, n, zt, e.reportAllChanges);
  ko(function() {
    var o = ft();
    if (o) {
      var i = o.responseStart;
      if (i <= 0 || i > performance.now()) return;
      n.value = Math.max(i - N(), 0), n.entries = [o], r(!0), E(function() {
        n = p("TTFB", 0), (r = m(t, n, zt, e.reportAllChanges))(!0);
      });
    }
  });
};
function L(t, e) {
  const n = parseFloat(t.value.toString()).toFixed(4);
  switch (t.name) {
    case "CLS":
      e.webVitalsCLS = n;
      break;
    case "TTFB":
      e.webVitalsTTFB = n;
      break;
    case "FID":
      e.webVitalsFID = n;
      break;
    case "LCP":
      e.webVitalsLCP = n;
      break;
    case "FCP":
      e.webVitalsFCP = n;
      break;
  }
}
function _o(t) {
  return t.desktop ? "desktop" : t.mobile ? "mobile" : "tablet";
}
function Fo(t) {
  const e = f(t).requestContext, n = e.location.name, r = e.pageId, o = e.nodeId, i = e.federalState, c = _o(e.device), u = window.utag_data ? window.utag_data.mslayer_page_name : "", s = window.utag_data ? window.utag_data.mslayer_page_level_2 : "", l = window.utag_data ? window.utag_data.mslayer_page_level_3 : "", z = window.utag_data ? window.utag_data.mslayer_app_version : "";
  return {
    // sunrise does not use page-level-caching at the moment
    cached: !1,
    city: n,
    state: i,
    pageId: r,
    nodeId: o,
    hasAds: "",
    breakpoint: c,
    url: window.location.href,
    level2Site: e.xitiPageLevel2,
    userAgent: window.navigator.userAgent,
    mslayer_page_name: u,
    mslayer_page_level_2: s,
    mslayer_page_level_3: l,
    mslayer_app_id: z,
    timeToRequest: 0,
    timeToFirstByte: 0,
    timeToDomLoaded: 0,
    timeToFullPageLoad: 0,
    webVitalsCLS: -1,
    webVitalsLCP: -1,
    webVitalsFCP: -1,
    webVitalsTTFB: -1,
    webVitalsFID: -1,
    redirects: -1,
    navigation: "",
    rawNavigationStart: -1,
    rawRedirectStart: -1,
    rawUnloadStart: -1,
    rawUnloadEnd: -1,
    rawRedirectEnd: -1,
    rawFetchStart: -1,
    rawDomainLookupStart: -1,
    rawDomainLookupEnd: -1,
    rawConnectStart: -1,
    rawSecureConnectionStart: -1,
    rawConnectEnd: -1,
    rawRequestStart: -1,
    rawResponseStart: -1,
    rawResponseEnd: -1,
    rawDomLoading: -1,
    rawDomInteractive: -1,
    rawDomContentLoadedEventStart: -1,
    rawDomContentLoadedEventEnd: -1,
    rawDomComplete: -1,
    rawLoadEventStart: -1,
    rawLoadEventEnd: -1
  };
}
function $o(t, e, n) {
  setTimeout(() => {
    if (n.navigation) {
      const r = n.navigation;
      switch (t.redirects = r.redirectCount, r.type) {
        case 0:
          t.navigation = "navigate";
          break;
        case 1:
          t.navigation = "reload";
          break;
        default:
          t.navigation = "unknown";
          break;
      }
    }
    if (n.timing) {
      const r = n.timing;
      t.timeToRequest = r.requestStart - r.navigationStart, t.timeToFirstByte = r.responseStart - r.requestStart, t.timeToDomLoaded = r.domContentLoadedEventEnd - r.navigationStart, t.timeToFullPageLoad = r.domComplete - r.navigationStart, t.rawNavigationStart = r.navigationStart, t.rawRedirectStart = r.redirectStart, t.rawUnloadStart = r.unloadEventStart, t.rawUnloadEnd = r.unloadEventEnd, t.rawRedirectEnd = r.redirectEnd, t.rawFetchStart = r.fetchStart, t.rawDomainLookupStart = r.domainLookupStart, t.rawDomainLookupEnd = r.domainLookupEnd, t.rawConnectStart = r.connectStart, t.rawSecureConnectionStart = r.secureConnectionStart, t.rawConnectEnd = r.connectEnd, t.rawRequestStart = r.requestStart, t.rawResponseStart = r.responseStart, t.rawResponseEnd = r.responseEnd, t.rawDomLoading = r.domLoading, t.rawDomInteractive = r.domInteractive, t.rawDomContentLoadedEventStart = r.domContentLoadedEventStart, t.rawDomContentLoadedEventEnd = r.domContentLoadedEventEnd, t.rawDomComplete = r.domComplete, t.rawLoadEventStart = r.loadEventStart, t.rawLoadEventEnd = r.loadEventEnd, t.hasAds = xo(), Ro(e, t);
    }
  }, 0);
}
function xo() {
  if (window.googletag && window.googletag.pubads) {
    const t = window.googletag.pubads();
    if (t && t.getSlots) {
      const e = t.getSlots();
      e && e.forEach((n) => n.getHtml() !== "" ? "google" : "none");
    }
  }
  return "none";
}
function Ro(t, e) {
  xe.post(t, JSON.stringify(e), {
    // the request must be sent as form-encoded because CORS does not allow application/json (see https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS)
    headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" }
  }).catch(() => {
  });
}
function Mo(t, e) {
  const n = f(t).navigationTiming;
  if (!e || Math.random() > n.frequency)
    return;
  const r = Fo(t);
  Lo((i) => L(i, r)), Oo((i) => L(i, r)), Po((i) => L(i, r)), Do((i) => L(i, r)), Ie((i) => L(i, r));
  let o = !1;
  window.addEventListener("load", () => {
    o || (o = !0, $o(r, n.url, e));
  });
}
function Uo() {
  document.querySelectorAll("[data-prg-href]").forEach((t) => {
    t.addEventListener("click", () => {
      const e = t, n = Bo(e.dataset.prgHref, e.dataset.sign, e.dataset.target);
      n && n.submit();
    });
  });
}
function Bo(t, e, n) {
  if (!t || !e)
    return;
  const r = document.createElement("form");
  return r.action = "?service=urlRedirect", r.method = "POST", n && (r.target = n), r.appendChild(Wt("url", t)), r.appendChild(Wt("sign", e)), document.body.appendChild(r), r;
}
function Wt(t, e) {
  const n = document.createElement("input");
  return n.type = "hidden", n.name = t, n.value = e, n;
}
function Ko(t) {
  var o;
  B.startListening();
  const e = _e({
    ...Oe,
    ...t.dynamicImports
  });
  D.initSourcepoint(), Uo();
  const n = window.performance || window.mozPerformance || window.msPerformance || window.webkitPerformance;
  Mo(e, n), Fe(e, t.trackingIntegrations || {});
  const r = f(e);
  Vo(t, r), ke(t, r) && (vo(e), ho((o = r.ads) == null ? void 0 : o.customSearchAds));
}
function Vo(t, e) {
  var r;
  const n = ((r = e.ads) == null ? void 0 : r.bsType) || null;
  window.ms = {
    bsType: ke(t, e) ? n : "noAds"
  };
}
function ke(t, e) {
  var n;
  return t.adsEnabled && ((n = e.ads) == null ? void 0 : n.adUnits.length);
}
export {
  Ko as initClient
};
//# sourceMappingURL=entry-client.js.map
